import useErrorHandledMutation from 'common/hooks/useErrorHandledMutation';

import { ReminderFrequency } from '../../types';
import { UpdateInvoiceReminderSettingsDocument } from './updateInvoiceReminderSettings.gql';

type InvoiceSettings = {
  isReminderEnabled: boolean;
  reminderFrequency: ReminderFrequency;
  reminderMaxOccurrences: number;
};

interface MutationResponseDataType {
  updateInvoice: {
    invoice: {
      settings: InvoiceSettings;
    };
  };
}

interface MutationVariabledDataType {
  input: {
    invoiceId: string;
    clientContactIds?: string[];
    isUserCcedOnEmails?: boolean;
    settings: Partial<InvoiceSettings>;
  };
}

const useUpdateInvoiceReminderSettings = () =>
  useErrorHandledMutation<MutationResponseDataType, MutationVariabledDataType>(
    UpdateInvoiceReminderSettingsDocument,
  );

export default useUpdateInvoiceReminderSettings;
